import React from 'react';
import { returnStatusColor } from './returnStatusColor';

const StatusPill = ({ dotColor, status }) => {
  return (
    <span
      className={`inline-block w-2 h-2 rounded-full cursor-pointer ${
        status === 'pending' ? 'animate-pulse' : ''
      }`}
      style={{
        backgroundColor: dotColor,
        boxShadow: status === 'pending' ? `0 0 0 2px white, 0 0 0 3px ${dotColor}` : undefined,
      }}
    ></span>
  );
};

const EventContent = ({ eventInfo }) => {
  const { title, extendedProps } = eventInfo.event;
  const { imageUrl, status } = extendedProps;
  const view = eventInfo.view.type;
  const { className, borderColor, backgroundColor } = returnStatusColor(status, view);

  // Custom styling for month view
  if (view === 'dayGridMonth') {
    return (
      <>
        <div
          className={`relative w-full h-22 flex items-center gap-2 p-1 overflow-hidden cursor-pointer rounded ${className}`}
          title={`${status.charAt(0).toUpperCase() + status.slice(1)}`}
        >
          <div className='flex items-center gap-2 flex-1 min-w-0'>
            {imageUrl && (
              <img
                src={imageUrl}
                alt='Post'
                className={`${
                  title === 'Story' ? 'w-12 h-22' : 'w-20 h-22'
                } rounded object-cover flex-shrink-0`}
              />
            )}
            <div className='flex-1 min-w-0'>
              <div className='text-xs font-medium truncate text-gray-900'>{title}</div>
              <div className='text-xs text-gray-600'>{eventInfo.timeText}</div>
            </div>
          </div>
        </div>
        <div className='absolute -top-3 -right-1 z-10'>
          <StatusPill dotColor={borderColor} status={status} />
        </div>
      </>
    );
  }
  return (
    <>
      <div
        className={`relative flex items-center overflow-hidden p-1 cursor-pointer rounded ${backgroundColor}`}
        title={`${status.charAt(0).toUpperCase() + status.slice(1)}`}
      >
        <div className='flex items-center gap-2 flex-1 min-w-0'>
          {imageUrl && (
            <img
              src={imageUrl}
              alt='Post'
              className={`${
                title === 'Story' ? 'w-5 h-9' : 'w-9'
              } rounded object-cover flex-shrink-0`}
            />
          )}
          <div className='flex-1 min-w-0'>
            <div className='text-sm text-gray-900 font-medium truncate'>{title}</div>
            <div className='text-xs opacity-75 text-gray-600'>{eventInfo.timeText}</div>
          </div>
        </div>
      </div>
      <div className='absolute -top-3 -right-1 z-9999'>
        <StatusPill dotColor={borderColor} status={status} />
      </div>
    </>
  );
};

export default EventContent;
